import React, { useEffect, useState } from "react";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import { useRecoilState, useRecoilValue } from "recoil";

import Close from "../../../assets/close.svg";
import CloseDark from "../../../assets/closedark.svg";
import { Add } from "../../../constants/Svgs";
import { darkModeState } from "../../../recoil/settings";
import { footerLinksState } from "../../../recoil/webpage";
import Button from "../../general/Button";
import ColorPickerWithPreview from "../../general/ColorPickerWithPreview";
import Input from "../../general/Input";
import Spacer from "../../general/Spacer";
import EditThemeHOC from "../EditThemeHOC";

import styles from "../../../styles/modals/Modal.module.css";

export default function EditFooter({ positionStyles, payload }) {
  const [open, setOpen] = useState(false);
  const dark = useRecoilValue(darkModeState);
  const [footerValues, setFooterValues] = useRecoilState(footerLinksState);
  const [instagram, setInstagram] = useState(footerValues.instagram);
  const [facebook, setFacebook] = useState(footerValues.facebook);
  const [twitter, setTwitter] = useState(footerValues.twitter);

  const [color, setColor] = useState(payload.value);

  useEffect(() => {
    setColor(payload.value);
  }, [payload.value, open]);

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <EditThemeHOC>
      <div
        className={styles.buttonContainer}
        style={{
          ...positionStyles,
        }}
      >
        <Button onClick={() => setOpen(true)} text={"Edit Footer"} />
      </div>

      <Modal
        className={` ${dark ? "dark" : ""}`}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
      >
        <Fade in={open}>
          <div className={styles.webpageModal}>
            <div className={styles.previewHeader}>
              <div>Editing Footer...</div>
              <img
                onClick={handleClose}
                src={dark ? CloseDark : Close}
                alt=""
              />
            </div>
            <div className={styles.content}>
              <div className={styles.label}>Facebook Link</div>
              <Input
                placeholder="Enter Link"
                value={facebook}
                onChange={(e) => setFacebook(e.target.value)}
              />
              <Spacer height={20} />
              <div className={styles.label}>Instagram Link</div>
              <Input
                placeholder="Enter Link"
                value={instagram}
                onChange={(e) => setInstagram(e.target.value)}
              />
              <Spacer height={20} />
              <div className={styles.label}>Twitter X Link</div>
              <Input
                placeholder="Enter Link"
                value={twitter}
                onChange={(e) => setTwitter(e.target.value)}
              />
              <Spacer height={20} />
              <div className={styles.pickerContainer}>
                <ColorPickerWithPreview
                  label={"Background colour"}
                  value={color}
                  onChange={(e) => setColor(e.target.value)}
                />
              </div>
              <div className="flex jc-fe">
                <Button
                  text="Save"
                  imgSrc={<Add />}
                  onClick={() => {
                    payload.setValue(color);
                    setFooterValues({
                      facebook,
                      instagram,
                      twitter,
                    });
                    handleClose();
                  }}
                />
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </EditThemeHOC>
  );
}
